import { Drawer } from "@renderbus/ui";
import styled from "styled-components";

export const CustomStyleDrawer = styled(Drawer)`
  .ant-drawer-wrapper-body {
    background: #343538;
  }
`;
